<template>
  <v-container>
    <h1 class="text-center mb-4">Калькулятор фьючерсов</h1>
    <div class="app-progress">
      <v-progress-linear
          v-if="progress"
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
          class="mb-3"
      ></v-progress-linear>
    </div>
    <v-layout wrap>
      <v-flex xs12 sm4 px-2>
        <v-card>
          <v-card-text>
            <v-text-field :loading="loading" class="mb-3" hide-details clearable rounded outlined @input="getFeatures" v-model="search" label="Поиск фьючерс"></v-text-field>
            <div class="mb-3" v-if="parseList && parseList.length">
              <h3 class="title">Выберите фьючерс</h3>
              <v-layout wrap>
                <v-btn
                    small
                    @click="changeFeature(item)"
                    :color="isFeatureActive(index) ? 'warning' : 'info'"
                    class="mx-1 my-1"
                    v-for="(item, index) in parseList"
                >
                  {{ item.title }}
                </v-btn>
              </v-layout>
            </div>
            <div class="top_features mb-3" v-if="topFeatures && topFeatures.length">
              <v-layout wrap>
                <v-btn
                    dark
                    @click="changeFeatureTop(item)"
                    :color="isTopFeatureActive(index) ? 'warning' : '#21a5ff'"
                    class="mx-1 my-1"
                    v-for="(item, index) in topFeatures"
                >
                  {{ item.title }}
                </v-btn>
              </v-layout>
            </div>
            <v-text-field
                rounded
                outlined
                hide-details
                class="mt-5"
                @input="doCalc('count_contracts')"
                v-model="form.count_contracts"
                label="Число контрактов"
                type="number"
            >
            </v-text-field>
            <div class="mb-5 mt-5">
              <v-btn @click="toggleBs" min-height="56" rounded v-if="form.calc_bs" dark block color="green" large>Купля</v-btn>
              <v-btn @click="toggleBs" min-height="56" rounded v-else dark block color="error" large>Продажа</v-btn>
            </div>
            <v-text-field rounded outlined @input="doCalc('target')" v-model="form.price_enter" label="Цена входа"></v-text-field>
            <v-text-field rounded filled disabled outlined v-model="form.go" readonly label="Требуемое ГО"></v-text-field>
            <v-text-field rounded filled disabled outlined hide-details v-model="form.size_position" readonly label="Размер позиции"></v-text-field>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8 px-2>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 px-2>
                <v-text-field rounded outlined dark @input="doCalc('target')" class="input_success" v-model="form.target" label="Цель"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field @input="doCalc('take_profit')" dark rounded outlined class="input_success" v-model="form.take_profit" label="Тейк, п"></v-text-field>
                <v-text-field @input="doCalc('profit_take')" dark rounded outlined class="mb-3 input_success" hide-details v-model="form.profit_take" label="Прибыль на тейке"></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider color="#eee"></v-divider>
            <v-layout wrap class="mt-3">
              <v-flex xs12 sm6 px-2>
                <v-text-field rounded outlined dark @input="doCalc('stop_loss')" class="input_error" v-model="form.stop_loss" label="Стоп-лосс"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field @input="doCalc('stop_p')" dark rounded outlined class="input_error" v-model="form.stop_p" label="Стоп, п"></v-text-field>
                <v-text-field @input="doCalc('loss_stop')"  dark rounded outlined class="input_error" hide-details v-model="form.loss_stop" label="Убыток на стопе"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 px-2>
                <v-text-field rounded outlined @input="doCalc('deposit')" v-model="form.deposit" label="Размер счета"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 px-2>
                <v-text-field rounded disabled filled outlined v-model="form.go_load" readonly label="Загрузка ГО от счета (%)"></v-text-field>
                <v-text-field rounded disabled filled hide-details outlined v-model="form.leverage" readonly label="Плечо"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        'search': null,
        'filter': {
          'id': '',
          'title': ''
        },
        'form': {
          'ajax': 1,
          'count_contracts': '',
          'price_enter': '',
          'go': '',
          'size_position': '',
          'target': '',
          'take_profit': '',
          'profit_take': '',
          'stop_loss': '',
          'calc_bs': 1,
          'stop_p': '',
          'loss_stop': '',
          'go_load': '',
          'leverage': '',
          'deposit': ''
        },
        'topFeatures': [],
        'parseList': [],
        'loading': false,
        'progress': false
      }
    },
    methods: {
      getTopFeatures() {
        let url = 'http://calc.smart-lab.ru/get_futures_by_vol.php';

        axios.get(url).then(response => {
          this.topFeatures = response.data
        })
      },
      getFeatures() {
        this.parseList = [];
        this.loading = true;
        let url = 'http://calc.smart-lab.ru/futures_suggest.php';

        axios.get(url, {params: {q: this.search}}).then(response => {
          this.parseList = response.data
          this.loading = false
        })
      },
      doCalc(field = false) {
        let url = 'http://calc.smart-lab.ru/futures_calc.php';
        this.progress = true;
        let self = this;
        let selfField = field

        setTimeout(()=> {
          axios.get(url, {params: {...self.form, ...self.filter}}).then(response => {
            if(self.form[selfField]) {
              let valueOfSelfField = self.form[selfField]
              self.form = {
                ...response.data,
                count_contracts: self.form.count_contracts,
                calc_bs: self.form.calc_bs,
              };
              self.form[selfField] = valueOfSelfField
            }
            this.progress = false
          })
        }, 1500)
      },
      changeFeature(item) {
        this.filter = { id: item.id, title: item.title};
        this.doCalc()
      },
      changeFeatureTop(item) {
        this.filter = { id: 'title', title: item.title};
        this.doCalc()
      },
      isFeatureActive(index) {
        return this.parseList[index].id == this.filter.id
      },
      isTopFeatureActive(index) {
        return this.topFeatures[index].title == this.filter.title
      },
      toggleBs() {
        this.form.calc_bs ? this.form.calc_bs = 0 : this.form.calc_bs = 1;
        this.doCalc()
      }
    },
    watch: {
      search() {
        this.getFeatures()
      },
    },
    mounted() {
      this.getTopFeatures()
    }
  }
</script>
